import React from 'react';

/* Props: 
productImage= Product Image , 
alt = alt text
*/
const DokanTableItemShortImage = ({ productImage, alt }) => (
    <div className="">
        <img
            src={productImage}
            alt={alt}
            className="border border-primary p-3 rounded-md h-16 w-16"
        />
    </div>
);

export default DokanTableItemShortImage;
